const reviewObserver = new MutationObserver((mutationList, observer) => {
  mutationList.forEach((mutation) => {
    const metaElement = mutation.target.querySelector('[itemprop="reviewCount"]');
    const reviewElement = mutation.target.querySelector('.bv_numReviews_text');
    if (!metaElement || !reviewElement) return;

    window.setInterval(() => {
      if (reviewElement.innerHTML != metaElement.getAttribute('content') + ' reviews') {
        reviewElement.innerHTML = metaElement.getAttribute('content') + ' reviews';
      }

      const stars = mutation.target.querySelectorAll('[style]:not(svg)');
      stars.forEach((star) => {
        star.removeAttribute('style');
      });
    }, 50);
  });
});

const reviewElements = document.querySelectorAll('.product__rating');

reviewElements.forEach((reviewElement) => {
  reviewObserver.observe(reviewElement, { childList: true, subtree: true });
});

window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false
};

theme.Currency = (function () {
  const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, { rootMargin: `0px 0px ${threshold}px 0px` });

  observer.observe(options.element);
};

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  };

  // Page transition
  window.addEventListener('beforeunload', () => {
    document.body.classList.add('unloading');
  });
  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded');
  });
  window.addEventListener('pageshow', (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove('unloading');
    }
  });

  // Viewport height
  function viewportHeight() {
    const platform = navigator?.userAgentData?.platform || navigator?.platform;
    if (/iPad|iPhone|iPod/.test(platform) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
    setHeaderHeight();
    setScrollbarWidth();
  }
  window.addEventListener('resize', viewportHeight);
  window.addEventListener('DOMContentLoaded', viewportHeight);

  if (document.body.getAttribute('data-page-rendering') !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap && el.attributeStyleMap.set('content-visibility', 'visible');
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: '50px 0px 100px 0px' }
    );
    const sections = document.querySelectorAll('.shopify-section + .shopify-section');
    sections.forEach((section) => { observer.observe(section); });
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1;
  var t;

  document.body.addEventListener('touchstart', function (i) {
    if (!i.target.closest('.flickity-slider')) {
      return e = !1;
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY
    };
  });

  document.body.addEventListener('touchmove', function (i) {
    if (e && i.cancelable) {
      var n = {
        x: i.touches[0].pageX - t.x,
        y: i.touches[0].pageY - t.y
      };
      Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
    }
  }, { passive: !1 });
})();

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = 'beyours:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  }
  catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);

    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}

function setHeaderHeight() {
  const header = document.getElementById('shopify-section-header');
  if (header) {
    document.documentElement.style.setProperty('--header-height', `${parseInt(header.getBoundingClientRect().bottom)}px`);
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
  if (charCode !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true;
    }
  }
  else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options, callback = null) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  if (callback) {
    form.addEventListener('submit', (event) => {
      callback();
    });
  }
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

class MenuDropdown extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      isActive: 'is-active'
    };

    this.addEventListener('focusin', this.openDropdown.bind(this));
    this.addEventListener('focusout', this.closeDropdown.bind(this));
    this.addEventListener('mouseover', this.openDropdown.bind(this));
    this.addEventListener('mouseleave', this.closeDropdown.bind(this));
  }

  openDropdown() {
    this.classList.add(this.classes.isActive);
  }

  closeDropdown() {
    this.classList.remove(this.classes.isActive);
  }
}
customElements.define('menu-dropdown', MenuDropdown);

class MenuDrawer extends HTMLElement {
  constructor(props) {
    super();

    this.classes = props ? props.classes : {
      open: 'menu-drawer--open',
      opening: 'menu-drawer--opening',
      closing: 'menu-drawer--closing'
    };

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setHeaderHeight();
    setScrollbarWidth();
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);

    setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    document.body.classList.add(this.classes.opening);

    this.openAnimation();
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.add('menu-closing');
      removeTrapFocus(elementToFocus);

      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);

      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent('close'));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  openAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing);
          detailsElement.classList.remove('menu-closing');
        }
        detailsElement.removeAttribute('open');

        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class CartDrawer extends MenuDrawer {
  constructor() {
    super({
      classes: {
        open: 'mini-cart--open',
        opening: 'mini-cart--opening',
        closing: 'mini-cart--closing'
      }
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super({
      classes: {
        open: 'facet-drawer--open',
        opening: 'facet-drawer--opening',
        closing: 'facet-drawer--closing'
      }
    });
  }
}
customElements.define('facet-drawer', FacetDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super({
      classes: {
        open: 'menu-mobile--open',
        opening: 'menu-mobile--opening',
        closing: 'menu-mobile--closing',
      }
    });
  }
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
      if (charCode === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(this.button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;

    this.poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      if (content.querySelector('video-section')) {
        this.appendChild(content).focus();
      } else {
        this.setAttribute('loaded', true);
        this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add('slider--no-buttons');
    } else {
      this.classList.remove('slider--no-buttons');
    }

    if (this.enableSliderLooping) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (isLastSlide || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}
customElements.define('slider-component', SliderComponent);

class ProductSliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scrollend', this.onScrollEvent.bind(this));
    this.prevButton.forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
    this.nextButton.forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      try {
        this.sliderItemOffset = this.sliderItemsToShow[0].scrollWidth;
      } catch (error) {
        this.sliderItemOffset = 0;
      }
      this.slidesPerPage = 1;
      this.totalPages = this.sliderItems.length;
    } else {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft ?? 0;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage ?? 1;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1 ?? 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.slider.querySelector('.is-active'),
        }
      }));
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add('slider--no-buttons');
    } else {
      this.classList.remove('slider--no-buttons');
    }

    if (this.enableSliderLooping) return;

    const isLastSlide = this.currentPage === this.sliderItems.length;

    if (this.slider.children[0].classList.contains('is-active')) {
      this.prevButton.forEach(button => button.setAttribute('disabled', 'disabled'));
    } else {
      this.prevButton.forEach(button => button.removeAttribute('disabled'));
    }

    if (isLastSlide || this.sliderItems[this.sliderItems.length - 1].classList.contains('is-active')) {
      this.nextButton.forEach(button => button.setAttribute('disabled', 'disabled'));
    } else {
      this.nextButton.forEach(button => button.removeAttribute('disabled'));
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const active = this.slider.querySelector('.is-active') || this.sliderItems[0];
    active.classList.remove('is-active');
    let newActive = active.previousElementSibling;

    if (event.target.closest('button').getAttribute('name') == 'next' && !theme.config.rtl) {
      newActive = active.nextElementSibling;
      this.currentPage = this.currentPage + 1;
    } else {
      this.currentPage = this.currentPage - 1;
    }

    newActive?.classList.add('is-active');
    this.update();
  }

  onScrollEvent(event) {
    if(window.outerWidth < 767) {
      const thumbnails = this.thumbnails;
      const mediaGallery = this.closest('media-gallery');

      this.slider.querySelectorAll('.slider__slide').forEach(el => {
        const inViewObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const thumbnailMediaId = entry.target.dataset.mediaId;
              const thumb = thumbnails.querySelector(`[data-target="${thumbnailMediaId}"]`);
              mediaGallery.setActiveThumbnail(thumb);
            }
          })
        }, { threshold: .5 })

        inViewObserver.observe(el);
      });
    }
  }

  connectedCallback() {
    this.slider = this.querySelector('[id^="Slider-"]');
    this.thumbnails = document.querySelector(`[id="Slider-Thumbnails-${this.slider.id.split('Slider-Gallery-')[1]}"]`);
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelectorAll('button[name="previous"]');
    this.nextButton = this.querySelectorAll('button[name="next"]');

    this.sliderItems[0].classList.add('is-active');

    if (!this.slider || !this.nextButton) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }
}
customElements.define('product-slider-component', ProductSliderComponent);

class ThumbnailSlider extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const variantItems = this.querySelectorAll('.thumbnail-list_item--variant:not(.is-active)');
    this.slider.dataset.mediaCount = this.sliderItems.length - variantItems.length;

    if (this.querySelector('[data-gang-option]')) {
      const inactiveGangItems = this.querySelectorAll('[data-gang-option]:not(.gang__active)');
      this.slider.dataset.mediaCount = this.sliderItems.length - inactiveGangItems.length;
    }

    if (this.slider.dataset.mediaCount < 2) this.classList.add('hidden');
  }
}
customElements.define('thumbnail-slider', ThumbnailSlider);

class QuoteSlider extends SliderComponent {
  constructor() {
    super();
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      this.sliderItems.forEach((element) => {
        element.removeAttribute('aria-current');
      });

      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      currentElement.setAttribute('aria-current', true);
    }
  }
}
customElements.define('quote-slider', QuoteSlider);

class ProductGallery extends ProductSliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const gallerySliderButtons = this.querySelector('.slider-buttons');
    if (gallerySliderButtons && this.querySelector('[data-gang-option]')) {
      if (this.querySelectorAll('.product__media-item.gang__active').length < 2) {
        gallerySliderButtons.classList.add('hidden');
      } else {
        gallerySliderButtons.classList.remove('hidden');
      }
    }

    this.cursor = this.querySelector('.gallery-cursor');
    if (!this.cursor) return;

    const images = this.querySelectorAll('.product__modal-opener--image');
    images.forEach((image) => image.addEventListener('mousemove', this.onMoveHandler.bind(this)));
    images.forEach((image) => image.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
    images.forEach((image) => image.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));
  }

  onMoveHandler(event) {
    this.cursor.style.left = `${event.clientX - 32}px`;
    this.cursor.style.top = `${event.clientY - 32}px`;
  }

  onEnterHandler() {
    this.cursor.classList.add('show');
  }

  onLeaveHandler() {
    this.cursor.classList.remove('show');
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      if (currentElement) {
        this.slider.style.setProperty('--force-image-ratio-percent', currentElement.querySelector('.media').style.getPropertyValue('--image-ratio-percent'));
      }
    }
  }

  goToFirstSlide() {
    this.slider.scrollTo({
      left: 0
    });
  }
}
customElements.define('product-gallery', ProductGallery);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // console.log(`VariantSelects constructor()`, this);
  }

  connectedCallback() {
    // console.log(`VariantSelects connectedCallback()`);
    this.variantData = this.getVariantData();
    this.variantExtendedData = this.getVariantExtendedData();
    this.masterSelect = this.querySelector('select.master-list');
    this.productId = this.masterSelect.getAttribute('data-product-id');
    this.masterOptions = this.masterSelect?.querySelectorAll('option');
    this.optionsLength = this.dataset.optionsLength;
    this.optionsMap = {};
    this.availableOptionsMap = {};
    this.unavailableOptionsMap = {};
    this.shiftedOption = null;
    this.setOptionsMap();
    this.addEventListener('change', this.onVariantChange);

     // Linked products
     this.masterSelectLinked = this.querySelector('select.master-list-linked-products');
     this.masterOptionsLinked = this.masterSelectLinked?.querySelectorAll('option');
     this.optionsMapLinked = {};
     this.availableOptionsMapLinked = {};
     this.unavailableOptionsMapLinked = {};
     this.linkedClass = 'linked-swatch';
     this.linkedSelector = `.${this.linkedClass}`;
     this.setOptionsMapLinked();
     this.setLinkedListeners();

    if(this.updateOptionsAvailability()){
      // console.log('this.updateOptionsAvailability() resulted in an existing variant. Continuing on.');
      this.updateOptions();
      this.updateMasterId();
      this.updateOptionsAvailabilityLinked();
    } else {
      // console.log('this.updateOptionsAvailability() resulted in a non-existant variant. Shifting to the next available variant.');
      this.shiftedOption?.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.updateAmazonButton();
  }

  disconnectedCallback() {
    window.originalProductId = window.originalProductId || this.productId;
  }

  setOptionsMap() {
    // console.log("setOptionsMap() start");

    const availableOptionsMap = {};
    const unavailableOptionsMap = {};

    if (!this.masterOptions) return;

    this.masterOptions.forEach((masterOption) => {
      const optionAvailable = masterOption.getAttribute('data-available');
      const length = parseInt(masterOption.getAttribute('data-length'));
      const option1 = masterOption.getAttribute('data-option-1');
      const option2 = masterOption.getAttribute('data-option-2');
      const option3 = masterOption.getAttribute('data-option-3');

      if (optionAvailable == "true") {
        availableOptionsMap['root'] = availableOptionsMap['root'] || [];
        availableOptionsMap['root'].push(option1);
        const uniqueOpt1 = [...new Set(availableOptionsMap['root'])];
        availableOptionsMap['root'] = uniqueOpt1;
        if (length > 1) {
          var key = option1;
          availableOptionsMap[key] = availableOptionsMap[key] || [];
          availableOptionsMap[key].push(option2);
          const uniqueOpt2 = [...new Set(availableOptionsMap[key])];
          availableOptionsMap[key] = uniqueOpt2;

        }
        if (length === 3) {
          var key = `${option1} / ${option2}`;
          availableOptionsMap[key] = availableOptionsMap[key] || [];
          availableOptionsMap[key].push(option3);
          const uniqueOpt3 = [...new Set(availableOptionsMap[key])];
          availableOptionsMap[key] = uniqueOpt3;
        }
      } else {
        unavailableOptionsMap['root'] = unavailableOptionsMap['root'] || [];
        unavailableOptionsMap['root'].push(option1);
        const uniqueOpt1 = [...new Set(unavailableOptionsMap['root'])];
        unavailableOptionsMap['root'] = uniqueOpt1;
        if (length > 1) {
          var key = option1;
          unavailableOptionsMap[key] = unavailableOptionsMap[key] || [];
          unavailableOptionsMap[key].push(option2);
          const uniqueOpt2 = [...new Set(unavailableOptionsMap[key])];
          unavailableOptionsMap[key] = uniqueOpt2;
        }
        if (length === 3) {
          var key = `${option1} / ${option2}`;
          unavailableOptionsMap[key] = unavailableOptionsMap[key] || [];
          unavailableOptionsMap[key].push(option3);
          const uniqueOpt3 = [...new Set(unavailableOptionsMap[key])];
          unavailableOptionsMap[key] = uniqueOpt3;
        }
      }
    });

    this.availableOptionsMap = availableOptionsMap;

    this.unavailableOptionsMap = unavailableOptionsMap;

    window.availableOptionsMap = availableOptionsMap;
    window.unavailableOptionsMap = unavailableOptionsMap;

    return this.optionsMap;
  }

  setOptionsMapLinked() {
    // console.log("setOptionsMapLinked() start");

    const availableOptionsMapLinked = {};
    const unavailableOptionsMapLinked = {};

    if (!this.masterOptionsLinked) return;

    this.masterOptionsLinked.forEach((masterOption) => {
      const optionAvailable = masterOption.getAttribute('data-available');
      const length = parseInt(masterOption.getAttribute('data-length'));
      const option1 = masterOption.getAttribute('data-option-1');
      const option2 = masterOption.getAttribute('data-option-2');
      const option3 = masterOption.getAttribute('data-option-3');

      if (optionAvailable == "true") {
        availableOptionsMapLinked['root'] = availableOptionsMapLinked['root'] || [];
        availableOptionsMapLinked['root'].push(option1);
        const uniqueOpt1 = [...new Set(availableOptionsMapLinked['root'])];
        availableOptionsMapLinked['root'] = uniqueOpt1;
        if (length > 1) {
          var key = option1;
          availableOptionsMapLinked[key] = availableOptionsMapLinked[key] || [];
          availableOptionsMapLinked[key].push(option2);
          const uniqueOpt2 = [...new Set(availableOptionsMapLinked[key])];
          availableOptionsMapLinked[key] = uniqueOpt2;

        }
        if (length === 3) {
          var key = `${option1} / ${option2}`;
          availableOptionsMapLinked[key] = availableOptionsMapLinked[key] || [];
          availableOptionsMapLinked[key].push(option3);
          const uniqueOpt3 = [...new Set(availableOptionsMapLinked[key])];
          availableOptionsMapLinked[key] = uniqueOpt3;
        }
      } else {
        unavailableOptionsMapLinked['root'] = unavailableOptionsMapLinked['root'] || [];
        unavailableOptionsMapLinked['root'].push(option1);
        const uniqueOpt1 = [...new Set(unavailableOptionsMapLinked['root'])];
        unavailableOptionsMapLinked['root'] = uniqueOpt1;
        if (length > 1) {
          var key = option1;
          unavailableOptionsMapLinked[key] = unavailableOptionsMapLinked[key] || [];
          unavailableOptionsMapLinked[key].push(option2);
          const uniqueOpt2 = [...new Set(unavailableOptionsMapLinked[key])];
          unavailableOptionsMapLinked[key] = uniqueOpt2;
        }
        if (length === 3) {
          var key = `${option1} / ${option2}`;
          unavailableOptionsMapLinked[key] = unavailableOptionsMapLinked[key] || [];
          unavailableOptionsMapLinked[key].push(option3);
          const uniqueOpt3 = [...new Set(unavailableOptionsMapLinked[key])];
          unavailableOptionsMapLinked[key] = uniqueOpt3;
        }
      }
    });

    this.availableOptionsMapLinked = availableOptionsMapLinked;

    this.unavailableOptionsMapLinked = unavailableOptionsMapLinked;

    window.availableOptionsMapLinked = availableOptionsMapLinked;
    window.unavailableOptionsMapLinked = unavailableOptionsMapLinked;

    return this.optionsMapLinked;
  }

  setLinkedListeners() {
    const colorSwatches = this.querySelector('.color-swatches');
    const linkedRadios = colorSwatches?.querySelectorAll(`input${this.linkedSelector}`);

    linkedRadios?.forEach((radio) => {
      radio.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.renderLinkedProduct(e.currentTarget);
      })
    })
  }

  getOptionsMapByLength(map, length) {
    if (!map) return;
    if (!length) return;
    // console.log("getOptionsMapByLength() start");
    const currentSelectedTitle = this.getCurrentSelectedTitle();
    const selectedOption = this.masterSelect.querySelector(`option[data-title="${CSS.escape(currentSelectedTitle)}"]`);

    let [selectedOption1, selectedOption2, selectedOption3] = ['', '', ''];
    // check if we could find an option under the selected title. If we cannot, we are dealing with an option combo that does not exist.
    if (!selectedOption) {
      // console.log(`No option in the master input under title "${currentSelectedTitle}"!`);
      // fake an option for now.
      const currentTitleSplit = currentSelectedTitle.split(' / ');
      length = currentTitleSplit.length;
      selectedOption1 = currentTitleSplit[0];
      switch (length) {
        case 2:
          selectedOption2 = currentTitleSplit[1];
          break;
        case 3:
          selectedOption2 = currentTitleSplit[1];
          selectedOption3 = currentTitleSplit[2];
          break;
        default:
          break;
      }
    } else {
      // console.log(selectedOption);
      length = parseInt(selectedOption.getAttribute('data-length'));
      selectedOption1 = selectedOption.getAttribute('data-option-1');
      selectedOption2 = selectedOption.getAttribute('data-option-2');
      selectedOption3 = selectedOption.getAttribute('data-option-3');
    }
    let mapKey = "";
    switch (length) {
      case 1:
        mapKey = "root";
        break;
      case 2:
        mapKey = `${selectedOption1}`;
        break;
      case 3:
        mapKey = `${selectedOption1} / ${selectedOption2}`;
        break;
      default:
        break;
    }
    // console.log(`mapKey: "${mapKey}"`);
    // console.log("getOptionsMapByLength() complete");
    return map[mapKey] || [];
  }

  getSelectedOptions() {
    return this.querySelectorAll(".variant-input-wrapper .select .select__select");
  }

  getCurrentSelectedTitle() {
    const selectedOptions = this.getSelectedOptions();
    const selectedValues = Array.from(selectedOptions).map(selectedOption => selectedOption.value);
    return selectedValues.join(" / ");
  }

  updateOptionsAvailability() {
    // console.log(`VariantSelects updateOptionsAvailability()`);
    let shiftVariant = false; // do we have to shift to the next available variant.
    let failedOption = null; // what option caused the shift to be necessary. move to the next available option in that option index. if no options are available in the index, move up to the previous index.
    const selectElements = Array.from(this.querySelectorAll('.variant-input-wrapper .select select'));
    const currentSelectedTitle = this.getCurrentSelectedTitle();
    const selectedOption = this.masterSelect.querySelector(`option[data-title="${currentSelectedTitle}" i]`);
    let length = 0;
    let [selectedOption1, selectedOption2, selectedOption3] = ['', '', ''];
    // check if we could find an option under the selected title. If we cannot, we are dealing with an option combo that does not exist.
    // make a fake option for now.
    if (!selectedOption) {
      // console.log(`No option in the master select under title "${currentSelectedTitle}"!`);
      const currentTitleSplit = currentSelectedTitle.split(' / ');
      length = currentTitleSplit.length;
      selectedOption1 = currentTitleSplit[0];
      switch (length) {
        case 2:
          selectedOption2 = currentTitleSplit[1];
          break;
        case 3:
          selectedOption2 = currentTitleSplit[1];
          selectedOption3 = currentTitleSplit[2];
          break;
        default:
          break;
      }
    } else {
      // console.log(`Option in the master select found under title "${currentSelectedTitle}"!`);
      length = parseInt(selectedOption.getAttribute('data-length'));
      selectedOption1 = selectedOption.getAttribute('data-option-1');
      selectedOption2 = selectedOption.getAttribute('data-option-2');
      selectedOption3 = selectedOption.getAttribute('data-option-3');
    }

    // console.log(`length: ${length}, selectedOption1: ${selectedOption1}, selectedOption2: ${selectedOption2}, selectedOption3: ${selectedOption3}`);

    // go through each select set
    selectElements.forEach((selectElement) => {
      // console.log(`Investigating selectElement `, selectElement);
      const selectIndex = parseInt(selectElement.getAttribute('data-option-index-int'));
      const selectedElementValue = selectElement.value;
      // for every option, reset the "style".
      const options = selectElement.querySelectorAll(`option`);
      options.forEach(option => {
        option.disabled = false;
        option.style.display = "block";
      });

      const selectedOption = selectElement.querySelector(`option[value="${selectedElementValue}"]`);
      // console.log('selectedOption: ', selectedOption);
      const selectedValue = selectedOption.value;
      let unavailableMap = this.getOptionsMapByLength(this.unavailableOptionsMap, selectIndex);
      let availableMap = this.getOptionsMapByLength(this.availableOptionsMap, selectIndex);

      // console.log("unavailableMap: ");
      // console.log(unavailableMap);
      // console.log("availableMap: ");
      // console.log(availableMap);

      if (selectIndex === length) {
        // is our current option unavailable?
        // console.log("selected option check start");
        if (unavailableMap && unavailableMap.includes(selectedValue)) {
          // console.log("This option's value is in the unavailable option map");
        } else if ((!(availableMap) || !(availableMap.includes(selectedValue))) && (!(unavailableMap) || !(unavailableMap.includes(selectedValue)))) {
          // this combo does NOT exist
          // console.log(`selected option with value "${selectedValue}" not found in either maps.`);
          selectedOption.style.display = "none";
          selectedOption.disabled = true;
          // shift to the next available option set.
          if (!shiftVariant && availableMap?.length > 0) {
            shiftVariant = true;
            failedOption = selectedOption;
          }
        }
        // console.log("selected option check complete");

        // look for siblings
        // console.log("sibling option check start");
        options.forEach((option) => {
          if (option.value === selectedValue) {
            return true;
          }
          if (unavailableMap && unavailableMap.includes(option.value)) {
            // console.log("This option's value is in the unavailable option map");
          } else if ((!(availableMap) || !(availableMap.includes(option.value))) && (!(unavailableMap) || !(unavailableMap.includes(option.value)))) {
            // this combo does NOT exist
            // console.log(`sibling option with value "${option.value}" not found in either maps.`);
            option.style.display = "none";
            option.disabled = true;
          }
        });
        // console.log("sibling option check complete");

        const keyPrefix = `${selectedOption1}`;
        const shouldCheckAvailableOptions = Object.keys(this.availableOptionsMap).some(key => key.startsWith(keyPrefix));
        // console.log(`Looking for additional unavailable maps for options on the above level that start with "${keyPrefix}" for "${selectedValue}"`);
        for (const key in this.unavailableOptionsMap) {
          if (key.startsWith(keyPrefix)) {
            // console.log(`Checking out map "${key}" for "${selectedValue}"`);
            const secondLevelSelectOption = this.querySelector(`.variant-input-wrapper select[data-index="2"] option[value="${key.split(' / ')[1]}"]`);
            if (!secondLevelSelectOption) {
              continue;
            }
            if (this.unavailableOptionsMap[key].includes(selectedValue)) {
              // console.log(`map "${key}" contains "${selectedValue}"`);
              this.setRadioClass(secondLevelSelectOption, 'disabled-radio');
            } else if (!shouldCheckAvailableOptions || !this.availableOptionsMap[key]?.includes(selectedValue)) {
              // console.log(`above level radio with value "${secondLevelSelectOption.value}" not found in either maps.`);
              secondLevelSelectOption.style.display = "none";
              secondLevelSelectOption.disabled = true;
            }
          }
        }
        if (shouldCheckAvailableOptions) {
          for (const key in this.availableOptionsMap) {
            if (key.startsWith(keyPrefix) && !this.unavailableOptionsMap[key]?.includes(selectedValue) && !this.availableOptionsMap[key]?.includes(selectedValue)) {
              // console.log(`Checking out map "${key}" for "${selectedValue}"`);
              const secondLevelSelectOption = this.querySelector(`.variant-input-wrapper select[data-index="2"] option[value="${key.split(' / ')[1]}"]`);
              if (!secondLevelSelectOption) {
                continue;
              }
              // console.log(`above level option with value "${secondLevelRadio.value}" not found in either maps.`);
              secondLevelSelectOption.style.display = "none";
              secondLevelSelectOption.disabled = true;
            }
          }
        }
      }
    });
    if (shiftVariant) {
      // console.log("The selected option combo resulted in a non-existant variant combination, shifting to the next available option set.");
      // here we have determined we should shift variant, most likely the customer changed one of the product options that equaled a hidden or non-existant combo. We want to move to the next available.
      let failedIndex = failedOption.dataset.index;
      let failedSelect = this.querySelector(`.variant-input-wrapper select[data-option-index="${failedIndex}"]`);
      if(failedSelect){
        let options = failedSelect.querySelectorAll('option');
        let newOption = Array.from(options).find(option => !option.disabled);
        if (newOption) {
          // console.log(newOption);
          failedSelect.value = newOption.value;
          newOption.selected = true;
          // failedSelect.dispatchEvent(new Event('change', { bubbles: true }));
          this.shiftedOption = failedSelect;
          return false;
        }
      }
    } else {
      return true;
    }
  }

  updateOptionsAvailabilityLinked() {
    if (!this.masterSelectLinked) return;

    // Check and update status of linked product swatches
    const fieldsets = this.querySelectorAll('fieldset');
    const currentSelectedTitle = this.getCurrentSelectedTitle();
    const selectedOption = this.masterSelect?.querySelector(`option[data-title="${CSS.escape(currentSelectedTitle)}"]`);
    let length = 0;
    let [selectedOption1, selectedOption2, selectedOption3] = ['', '', ''];
    // check if we could find an option under the selected title. If we cannot, we are dealing with a linked option combo that does not exist.
    // make a fake option for now.
    if (!selectedOption) {
      const currentTitleSplit = currentSelectedTitle.split(' / ');
      length = currentTitleSplit.length;
      selectedOption1 = currentTitleSplit[0];
      switch (length) {
        case 2:
          selectedOption2 = currentTitleSplit[1];
          break;
        case 3:
          selectedOption2 = currentTitleSplit[1];
          selectedOption3 = currentTitleSplit[2];
          break;
        default:
          break;
      }
    } else {
      length = parseInt(selectedOption.getAttribute('data-length'));
      selectedOption1 = selectedOption.getAttribute('data-option-1');
      selectedOption2 = selectedOption.getAttribute('data-option-2');
      selectedOption3 = selectedOption.getAttribute('data-option-3');
    }

    // go through each radio option set
    fieldsets.forEach((fieldset) => {
      const radioIndex = parseInt(fieldset.getAttribute('data-option-index-int'));

      // for every linked radio, reset the style.
      const radios = fieldset.querySelectorAll(`input${this.linkedSelector}`);
      radios.forEach(radio => {
        radio.disabled = false;
        radio.classList.remove('disabled-radio');
        radio.classList.remove('does-not-exist');
      });

      const selectedRadio = fieldset.querySelector(`.product-form__input-option:checked`);
      const selectedValue = selectedRadio.value;
      let unavailableMap = this.getOptionsMapByLength(this.unavailableOptionsMapLinked, radioIndex);
      let availableMap = this.getOptionsMapByLength(this.availableOptionsMapLinked, radioIndex);

      if (radioIndex === length) {
        // look for siblings
        radios.forEach((radio) => {
          if (unavailableMap && unavailableMap.includes(radio.value)) {
            radio.classList.add('disabled-radio');
          } else if ((!(availableMap) || !(availableMap.includes(radio.value))) && (!(unavailableMap) || !(unavailableMap.includes(radio.value)))) {
            // this linked combo does NOT exist
            radio.classList.add('does-not-exist');
            radio.disabled = true;
          }
        });

        // For linked swatches on products without a 3rd variant option
        const keyPrefix = `${selectedOption1}`;
        const shouldCheckAvailableOptions = Object.keys(this.availableOptionsMapLinked).some(key => key.startsWith(keyPrefix));
        for (const key in this.unavailableOptionsMapLinked) {
          if (key.startsWith(keyPrefix)) {
            const secondLevelRadio = this.querySelector(`.product-form__input-option${this.linkedSelector}[data-index="2"][value="${key.split(' / ')[1]}"]`);
            if (!secondLevelRadio) {
              continue;
            }
            if (this.unavailableOptionsMapLinked[key].includes(selectedValue)) {
              this.setRadioClass(secondLevelRadio, 'disabled-radio');
            } else if (!shouldCheckAvailableOptions || !this.availableOptionsMapLinked[key]?.includes(selectedValue)) {
              this.setRadioClass(secondLevelRadio, 'does-not-exist');
              secondLevelRadio.disabled = true;
            }
          }
        }
        if (shouldCheckAvailableOptions) {
          for (const key in this.availableOptionsMapLinked) {
            if (key.startsWith(keyPrefix) && !this.unavailableOptionsMapLinked[key]?.includes(selectedValue) && !this.availableOptionsMapLinked[key]?.includes(selectedValue)) {
              const secondLevelRadio = this.querySelector(`.product-form__input-option${this.linkedSelector}[data-index="2"][value="${key.split(' / ')[1]}"]`);
              if (!secondLevelRadio) {
                continue;
              }
              this.setRadioClass(secondLevelRadio, 'does-not-exist');
              secondLevelRadio.disabled = true;
            }
          }
        }
      }
    });
  }

  onVariantChange(event) {
    // console.log("onVariantChange", event);
    if(this.updateOptionsAvailability()){
      // console.log("updateOptionsAvailability() resulted in a valid variant, continuing onVariantChange.");
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.validateGang();
      this.updateURL();
      this.updateButtonStyle();
      this.updateOptionsAvailabilityLinked();
      this.updateColorMessaging();
      this.updateColorGroups();
      this.updateColorLabels();

      if (!this.currentVariant) {
        // if we are here, then the current selection is a non-existant or hidden variant combo.
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        if (this.gangOption) {
          this.updateGangMedia();
        } else {
          this.updateMedia();
        }
        this.updateVariantInput();
        this.renderProductInfo();

        this.updateVariantMetaFieldsContents();
      }
      this.handleStickyCart(event.target);
    } else {
      // console.log("updateOptionsAvailability() resulted in a variant shift, ending onVariantChange early.");
      this.shiftedOption?.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.updateAmazonButton();
    soldOut();
  }

  updateVariantMetaFieldsContents() {
    const metaFields = this.variantExtendedData?.[this.currentVariant?.id];
    const estimatedShippingInputs = document.querySelectorAll('.js-variant-estimated-shipping-time');
    const estimatedShippingLabels = document.querySelectorAll('.js-variant-estimated-shipping-time-label');

    if (!estimatedShippingInputs
      || estimatedShippingInputs.length === 0
      || !estimatedShippingLabels
      || estimatedShippingLabels.length === 0
      || !metaFields) return;

    const shouldShowEstimatedShipping =
      metaFields?.inventory_policy !== 'deny' &&
      Number(metaFields?.inventory_quantity) <= 0 &&
      metaFields?.estimated_shipping !== ''

    const value = shouldShowEstimatedShipping ? metaFields.estimated_shipping : '';

    for (let i = 0; i < estimatedShippingInputs.length; i++) {
      estimatedShippingInputs[i].value = value;
    }

    for (let i = 0; i < estimatedShippingLabels.length; i++) {
      estimatedShippingLabels[i].textContent = shouldShowEstimatedShipping ? value : '';
      shouldShowEstimatedShipping ? estimatedShippingLabels[i].classList.remove('visually-hidden') : estimatedShippingLabels[i].classList.add('visually-hidden');
      shouldShowEstimatedShipping ? estimatedShippingLabels[i].setAttribute('aria-hidden', 'false') : estimatedShippingLabels[i].setAttribute('aria-hidden', 'true');
    }
  }

  updateAmazonButton() {
    document.querySelector('.product-form__buttons')?.classList.toggle('amazon-override',  false);
    let selectedOptionId = document.querySelector('.product product-form input[name="id"]').value;
    let amazonLinksArray = Array.from(document.querySelectorAll('.product .variant_amazon_link'));
    let amazonBtn = document.querySelector('.product .amazon-btn');
    for (const link of amazonLinksArray) {
      const match = link.dataset.variantId === selectedOptionId;
      amazonBtn.href = match ? link.href : '';
      amazonBtn.classList.toggle('hidden', !match);
      if (match) {
        document.querySelector('.product-form__buttons')?.classList.toggle('amazon-override',  true);
        document.querySelector('.product-form__buttons').querySelector('.product-form__submit').textContent = 'Coming Soon';
        break;
      }
    }
  }

  handleStickyCart(target) {
    const stickyCart = document.getElementById(`sticky-cart-${this.dataset.section}`);
    if (!stickyCart) return;

    const attribute = target.getAttribute('name');

    document.querySelectorAll(`variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`)
      .forEach((input) => {
        if (input.tagName === 'INPUT') {
          input.checked = input.value === target.value;
        }
        else {
          input.value = target.value;
        }
      });

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const image = document.querySelector('.sticky-cart__content-image img');
    if (image) {
      image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`;
      image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`;
      image.width = 70;
      image.height = Math.ceil(70 / this.currentVariant.featured_media.preview_image.aspect_ratio);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateColorMessaging() {
    const allMessages = this.querySelectorAll('.variant__message-box');
    const selectedVariantTitle1 = this.currentVariant.option1;
    const selectedVariantTitle2 = this.currentVariant.option2;
    const colorSwatches = this.querySelector('.color-swatches');

    //remove previous messages
    document.querySelectorAll('.color__swatch-limited').forEach((el) => el.remove());
    document.querySelectorAll('.color__swatch-sold-out').forEach((el) => el.remove());
    document.querySelectorAll(`.color__swatch-tooltip`).forEach((el) => el.classList.remove('sold-out'));

    if(allMessages.length > 0 && colorSwatches) {
      allMessages.forEach((messageEl) => {
        const totalOptions = Number(messageEl.dataset.totalOptions);
        let moveForward = false;
        if(totalOptions === 3 && selectedVariantTitle1 == messageEl.dataset.title1 && selectedVariantTitle2 == messageEl.dataset.title2) {
          moveForward = true;
        }

        if(totalOptions === 2 && selectedVariantTitle1 == messageEl.dataset.title1) {
          moveForward = true;
        }

        if(moveForward) {
          // Target the correct swatch, either current product or linked
          let colorSelector = colorSwatches.querySelector(`span:not(${this.linkedSelector})[data-color-name="${messageEl.dataset.variantColor}"]`);
          if (messageEl.classList.contains(this.linkedClass)) {
            colorSelector = colorSwatches.querySelector(`span${this.linkedSelector}[data-color-name="${messageEl.dataset.variantColor}"]`);
          }
          const messageHtml = document.createElement('span');
          const messageText = messageEl.dataset.message;
          let className = 'color__swatch-limited';
          if(messageText.toLowerCase().includes('sold out')){
            className = 'color__swatch-sold-out';
            colorSelector.classList.add('sold-out');
          }
          messageHtml.classList.add(className);
          messageHtml.style.color = messageEl.dataset.color;
          messageHtml.innerHTML = messageEl.dataset.message;
          colorSelector.parentNode.insertBefore(messageHtml, colorSelector.nextSibling)
        }
      });
    }
  }

  // Update swatch color groupings dynamically
  updateColorGroups() {
    // Get the color swatches and find the color option index
    const colorSwatches = this.querySelector('.color-swatches');
    const colorRadios = colorSwatches?.querySelectorAll(`input:not(${this.linkedSelector})`);

    if (!colorRadios) return;

    const colorIndex = colorRadios[0]?.getAttribute('data-index');

    // Get current options indices without color index
    const optionsArray = Array.from(Array(this.options.length)).map((e,i)=>i+1).filter(num => num !== parseInt(colorIndex));
    // Get currently selected options selectors and correct attribute, e.g. data-option-1="Letter"
    const optionsSelector = optionsArray
      .map((option) => `[data-option-${option}="${CSS.escape(this.options[option - 1])}"]`)
      .join('');

    const assignSwatchGroup = (radio, linked = false) => {
      // Find the correct variant for the radio within the master select options
      const radioVal = radio.getAttribute('value');
      const masterSelectVariable = linked ? this.masterSelectLinked : this.masterSelect;
      const masterSelectOption = masterSelectVariable?.querySelector(
        `${optionsSelector}[data-option-${colorIndex}="${CSS.escape(radioVal)}"]`
      );

      // Get the variant's swatch group from the master select option
      const swatchGroup = masterSelectOption?.dataset.swatchGroup;
      if (swatchGroup) {
        // Update swatch-group on variant radio
        radio.setAttribute('data-swatch-group', swatchGroup);
        const swatchGroupParent = colorSwatches.querySelector(`[data-swatch-group-parent="${swatchGroup}"`);
        // Move swatch into the correct swatch group
        if (swatchGroupParent) {
          const radioParent = radio.closest('.js-input-wrapper');
          swatchGroupParent.append(radioParent);
        }
      }
    }

    // Move swatches into correct group
    colorRadios?.forEach((radio) => {
      assignSwatchGroup(radio);
    });

    // Move linked swatches into correct group
    const colorRadiosLinked = colorSwatches?.querySelectorAll(`input${this.linkedSelector}`);
    colorRadiosLinked?.forEach((radio) => {
      assignSwatchGroup(radio, true);
    });

    // Once all swatches moved to correct color group, sort groups based on swatch positions
    const swatchGroupParents = colorSwatches.querySelectorAll('[data-swatch-group-parent]');
    swatchGroupParents.forEach((parent) => {
      [...parent.children]
      .sort((a, b) => {
        const inputA = a.querySelector('input');
        const inputB = b.querySelector('input');
        // Sort by swatch position
        if (parseInt(inputA.dataset.swatchPosition) !== parseInt(inputB.dataset.swatchPosition)) {
          return parseInt(inputA.dataset.swatchPosition) > parseInt(inputB.dataset.swatchPosition) ? 1 : -1
        } else {
          // Fall back to swatch name if position numbers are the same
          return inputA.value > inputB.value ? 1 : -1
        }
      })
      .forEach(node => parent.appendChild(node));

      // Finally, update the active color label for the color group
      const parentSelectedLabel = parent.closest('.form__group')?.querySelector('.form__label-selected');
      if (parentSelectedLabel) {
        if (parent.querySelector('input:checked')) {
          parentSelectedLabel.innerHTML = `<span class="selected-label">SELECTED COLOR:</span> ${parent.querySelector('input:checked').value}`;
        } else {
          parentSelectedLabel.innerHTML = '';
        }
      }
    });
  }

  // Update swatch color group labels dynamically
  updateColorLabels() {
    const colorSwatches = this.querySelector('.color-swatches');

    // Update the swatch parent label based on swatch totals
    const swatchGroupParents = colorSwatches?.querySelectorAll('[data-swatch-group-parent]');
    swatchGroupParents?.forEach((group) => {
      // Find how many swatches are in the color group
      const totalSwatches = group.querySelectorAll('input:not(.does-not-exist)').length;

      // Update the group label with the correct number of swatches
      const groupWrapper = group.closest('[data-swatch-group-label]');
      groupWrapper.querySelector('[data-swatch-total]').textContent = totalSwatches;

      // Hide the entire color group if it contains 0 swatches
      if (totalSwatches > 0) {
        groupWrapper?.classList.remove('hidden');
      } else {
        groupWrapper?.classList.add('hidden');
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  validateGang() {
    const mediaItemWithGang = document.querySelector(`#shopify-section-${this.dataset.section} [data-gang-option]`);
    if (mediaItemWithGang) {
      this.gangOption = mediaItemWithGang.dataset.gangOption;
    }
  }

  updateGangMedia() {
    if (!this.gangOption) return;

    const variantInputWrapper = this.querySelector('.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]');
    if (variantInputWrapper) {
      this.gangIndex = variantInputWrapper.dataset.optionIndex;
    } else {
      this.gangOption = null;
    }

    if (!this.currentVariant) return;
    //if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const gangValue = this.getSlug(this.currentVariant[this.gangIndex]);
    if (this.currentGangValue !== gangValue) {
      document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect]`
      ).forEach(function (media) {
        media.classList.remove('gang__active');
      });

      this.currentGangValue = gangValue;
      var gangConnect = this.gangOption + '_' + gangValue;
      const newMedias = document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"]`
      );

      if (!newMedias.length) return;
      Array.from(newMedias).reverse().forEach(function (newMedia) {
        newMedia.classList.add('gang__active');
        let parent = newMedia.parentElement;
        if (parent.firstChild != newMedia) {
          parent.prepend(newMedia);
          parent.classList.add('product__media-no-animate');
        }
      });

      const thumbnailSlider = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);
      if (thumbnailSlider) {
        const inactiveItems = thumbnailSlider.querySelectorAll('.thumbnail-list__item:not(.gang__active)');
        thumbnailSlider.slider.dataset.mediaCount = thumbnailSlider.sliderItems.length - inactiveItems.length;
        if (thumbnailSlider.slider.dataset.mediaCount < 2) {
          thumbnailSlider.classList.add('hidden');
        } else {
          thumbnailSlider.classList.remove('hidden');
        }
        thumbnailSlider.resetPages();
      }

      if (!mediaGallery) {
        const productGallery = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery`);
        if (productGallery) {
          productGallery.resetPages();
          productGallery.goToFirstSlide();
        }
      }

      const gallerySliderButtons = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .slider-buttons`);
      if (gallerySliderButtons) {
        if (document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active`).length < 2) {
          gallerySliderButtons.classList.add('hidden');
        } else {
          gallerySliderButtons.classList.remove('hidden');
        }
      }
    }

    if (!this.currentVariant.featured_media) {
      if (!document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active`).length) {
        document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active`).classList.add('is-active');
      }
      return;
    }

    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }

    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  getSlug(someString) {
    return someString.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }

  updateMedia() {
    if (!this.currentVariant) return;
    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && mediaGallery.classList.contains('variant-level-media')) {
      const currentUrl = window.location.href;

      fetch(currentUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
        })
        .then(text => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const mediaGallery = doc.querySelector('media-gallery');
            const productModal = doc.querySelector('product-modal');
            if (mediaGallery) {
                const currentMediaGallery = document.querySelector('media-gallery');
                if (currentMediaGallery) {
                    currentMediaGallery.replaceWith(mediaGallery);
                }
            }
            if (productModal) {
                const currentModal = document.querySelector('product-modal');
                if (currentModal) {
                    currentModal.replaceWith(productModal);
                }
            }

        })
        .catch(error => {
            console.error('Error fetching or processing the page:', error);
        });

      const mediaGallery = document.querySelector("media-gallery");
      if (!mediaGallery) {
        const productGallery = document.querySelector("media-gallery product-gallery");
        if (productGallery) {
          productGallery.resetPages();
          productGallery.goToFirstSlide();
        }
      }
    }else {
      if (!this.currentVariant.featured_media) return;
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );

      if (!newMedia) return;

      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      parent.prepend(newMedia);
      parent.classList.add('product__media-no-animate');

      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      if (mediaGallery) {
        const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
      }

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (modalContent) {
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
      }

      const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
      if (thumbnailContent) {
        const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        thumbnailContent.prepend(newMediaThumbnail);
      }
    }
  }

  updateURL() {
    if (this.dataset.updateUrl === 'false') return;
    let variantUrl = ``;
    if (this.currentVariant) {
      if(this.closest('.product-kit')) {
      } else {
        variantUrl = `?variant=${this.currentVariant.id}`;
        window.history.replaceState({}, '', `${this.dataset.url}${variantUrl}`);
      }
    }

  }

  updateVariantInput() {
    const productFormsTwo = document.querySelectorAll(`#product-form-${this.dataset.section}--kit`);
    productFormsTwo.forEach((productFormTwo) => {
      if(this.closest('.product-kit')) {
        const input = this.closest('.product-kit').querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    // console.log("updatePickupAvailability()");
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    // console.log(pickUpAvailability);
    if (this.currentVariant && this.currentVariant.available) {
      // console.log(this.currentVariant);
      // console.log(this.currentVariant.available);
      try{
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } catch(error){
        console.error(error);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm){
      // try{
      //   productForm.handleErrorMessage();
      // } catch(error){
      //   console.error(error);
      // }
    }
  }

  renderProductInfo() {
    // console.log("renderProductInfo");
    //update price elements
    this.updatePrice(this.currentVariant.price);

    this.closest('section').classList.add('is-loading');
    if (this.currentVariant) this.toggleAddButton(!this.currentVariant.available, variantStrings.soldOut);

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        this.updateSKU(responseText);
        this.updatePriceAlt(responseText);
        this.updateColorName(responseText);
        this.updateButtonStyle();
        this.updateColorMessaging();
        this.updateInventoryStatus(responseText);
      })
      .catch((e) => {
        console.error(e);
      }).finally(() => {
        this.closest('section').classList.remove('is-loading');
      });
  }

  renderLinkedProduct(target) {
    if (!this.masterSelectLinked) return;

    const colorIndex = target.getAttribute('data-index');

    // Get current options indices without color index
    const optionsArray = Array.from(Array(this.options.length)).map((e,i)=>i+1).filter(num => num !== parseInt(colorIndex));
    // Get currently selected options selectors and correct attribute, e.g. data-option-1="Letter"
    const optionsSelector = optionsArray.map((option) => `[data-option-${option}="${this.options[option - 1]}"]`).join('');

    // Find the correct variant for the radio within the master select options
    const radioVal = target.getAttribute('value');
    const masterSelectOption = this.masterSelectLinked?.querySelector(`${optionsSelector}[data-option-${colorIndex}="${radioVal}"]`);

    // Get the product URL for linked variant
    const productUrl = masterSelectOption.getAttribute('data-variant-url');
    const productId = masterSelectOption.getAttribute('data-product-id');

    if (!productUrl) return;
    // update page url
    window.history.replaceState({}, '', `${productUrl}`);

    fetch(
      `${productUrl}`
    )
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      document.getElementById('MainContent').innerHTML = html.getElementById('MainContent').innerHTML;

      // Klaviyo BIS button
      const klaviyoBISButton = document.querySelector('.product-form__buttons .klaviyo-bis-trigger');
      // Only show BIS button for originally loaded product; for linked products just show sold out
      if (productId !== window.originalProductId) {
        klaviyoBISButton?.remove();
      }
      this.updateAmazonButton();
      // Yotpo refresh
      if (yotpoWidgetsContainer) yotpoWidgetsContainer.initWidgets();
    })
  }

  updateSKU(responseText) {
    const id = `sku-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updatePrice(variantPrice) {
    const price = `$${Shopify.formatMoney(variantPrice, '{{amount}}')}`
    const priceElements = document.querySelectorAll('.product__price');
    const price_whole = price.split(".")[0];
    const remove_symbol =  price_whole.replace(/\$/g, '');
    const price_decimal = price.split(".")[1];
    const decimal_dots = "." + price_decimal ;
    priceElements.forEach((ele) => {
      if(this.closest('.product-kit')) {
        this.closest('.product-kit').querySelector('ins').innerHTML = price;
      } else {
        ele.querySelector('ins').innerHTML = price;
        ele.classList.remove('visibility-hidden');
      }
    });

  }

  updatePriceAlt(responseText) {
    //TODO: determine what this is doing...
    return;
    const id = `price-${this.dataset.section}--alt`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateColorName(responseText) {
    const id = `color-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateButtonStyle() {
    this.documentRef = this.closest('.quick-view') ?? document;

    if(this.closest('.product-kit')){
      this.documentKit = this.closest('.product-kit') ?? document;
      const productKitSelectedColorOption = this.documentKit.querySelector('.color-swatches input:checked + label');
      const kitAddButton = this.documentKit.querySelector('[name="add"]');
      kitAddButton.setAttribute('style', productKitSelectedColorOption.getAttribute('style'));
    }else{
      const  wrapper = document.querySelector(this.hasAttribute('data-selector') ? this.getAttribute('data-selector') : `#ProductInfo-${this.dataset.section}`);
      const  submit = wrapper.querySelector('[type="submit"]');
      const addButton = this.documentRef != document ? this.documentRef.querySelector('[name="add"]') : wrapper.querySelector('[name="add"]');
      const stickyAddButton = this.documentRef.querySelector('.sticky-cart__form [name="add"]');
      const upsellAddButton = this.documentRef.querySelector('.js-upsell-add');
      const selectedColorOption = this.documentRef != document ? this.documentRef.querySelector('.color-swatches input:checked + label') : wrapper.querySelector('.color-swatches input:checked + label');

      const klaviyoButton = this.documentRef.querySelector('.klaviyo-bis-trigger');
      const addButtons = this.documentRef.querySelectorAll('[name="add"]');

      const buttons = [submit, addButton, stickyAddButton, upsellAddButton, klaviyoButton, ...addButtons];

      buttons.forEach((button) => {
        if (!button || !selectedColorOption) return;
        button.setAttribute('style', selectedColorOption.getAttribute('style'));
        button.classList.add('__styled');
      });
    }
  }

  updateInventoryStatus(responseText) {
    const id = `inventory-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]:not(upsell-add)');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text && !addButton.hasAttribute('data-ignore')) addButton.textContent = text;
      }
      else {
        addButton.removeAttribute('disabled');
        if (!addButton.hasAttribute('data-ignore')) addButton.textContent = addButton.dataset.preOrder === 'true' ? variantStrings.preOrder : variantStrings.addToCart;
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = variantStrings.unavailable;

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.add('visibility-hidden');

      const priceAlt = document.getElementById(`price-${this.dataset.section}--alt`);
      if (priceAlt) priceAlt.classList.add('visibility-hidden');

      const inventory = document.getElementById(`inventory-${this.dataset.section}`);
      if (inventory) inventory.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    return JSON.parse(this.querySelector('script[type="application/json"].js-variant-data').textContent);
  }

  getVariantExtendedData() {
    return JSON.parse(this.querySelector('script[type="application/json"].js-variant-extended-data').textContent);
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // console.log(`VariantRadios constructor()`, this);
  }

  connectedCallback() {
    super.connectedCallback();  // Call parent's connectedCallback
    // console.log(`VariantRadios connectedCallback()`);
  }

  getSelectedOptions() {
    return this.querySelectorAll(".variant-input-wrapper input:checked");
  }

  updateOptionsAvailability() {
    // console.log(`VariantRadios updateOptionsAvailability()`);
    let shiftVariant = false; // do we have to shift to the next available variant.
    let failedOption = null; // what option caused the shift to be necessary. move to the next available option in that option index. if no options are available in the index, move up to the previous index.
    const fieldsets = this.querySelectorAll('fieldset');
    const currentSelectedTitle = this.getCurrentSelectedTitle();
    const selectedOption = this.masterSelect?.querySelector(`option[data-title="${CSS.escape(currentSelectedTitle)}"]`);
    let length = 0;
    let [selectedOption1, selectedOption2, selectedOption3] = ['', '', ''];
    // check if we could find an option under the selected title. If we cannot, we are dealing with an option combo that does not exist.
    // make a fake option for now.
    if (!selectedOption) {
      // console.log(`No option in the master select under title "${currentSelectedTitle}"!`);
      const currentTitleSplit = currentSelectedTitle.split(' / ');
      length = currentTitleSplit.length;
      selectedOption1 = currentTitleSplit[0];
      switch (length) {
        case 2:
          selectedOption2 = currentTitleSplit[1];
          break;
        case 3:
          selectedOption2 = currentTitleSplit[1];
          selectedOption3 = currentTitleSplit[2];
          break;
        default:
          break;
      }
    } else {
      // console.log(`Option in the master select found under title "${currentSelectedTitle}"!`);
      length = parseInt(selectedOption.getAttribute('data-length'));
      selectedOption1 = selectedOption.getAttribute('data-option-1');
      selectedOption2 = selectedOption.getAttribute('data-option-2');
      selectedOption3 = selectedOption.getAttribute('data-option-3');
    }

    // console.log(`length: ${length}, selectedOption1: ${selectedOption1}, selectedOption2: ${selectedOption2}, selectedOption3: ${selectedOption3}`);

    // go through each radio option set
    fieldsets.forEach((fieldset) => {
      // console.log(`Investigating fieldset `, fieldset);
      const radioIndex = parseInt(fieldset.getAttribute('data-option-index-int'));

      // for every radio, reset the style.
      const radios = fieldset.querySelectorAll(`input:not(${this.linkedSelector})`);
      radios.forEach(radio => {
        radio.disabled = false;
        radio.classList.remove('disabled-radio');
        radio.classList.remove('does-not-exist');
      });

      const selectedRadio = fieldset.querySelector(`.product-form__input-option:checked`);
      // console.log('selectedRadio: ', selectedRadio);
      const selectedValue = selectedRadio.value;
      let unavailableMap = this.getOptionsMapByLength(this.unavailableOptionsMap, radioIndex);
      let availableMap = this.getOptionsMapByLength(this.availableOptionsMap, radioIndex);

      // console.log("unavailableMap: ");
      // console.log(unavailableMap);
      // console.log("availableMap: ");
      // console.log(availableMap);

      if (radioIndex === length) {
        // is our current radio unavailable?
        // console.log("selected radio check start");
        if (unavailableMap && unavailableMap.includes(selectedValue)) {
          // console.log("This radio's value is in the unavailable option map");
          selectedRadio.classList.add('disabled-radio');
        } else if ((!(availableMap) || !(availableMap.includes(selectedValue))) && (!(unavailableMap) || !(unavailableMap.includes(selectedValue)))) {
          // this combo does NOT exist
          // console.log(`selected radio with value "${selectedValue}" not found in either maps.`);
          selectedRadio.classList.add('does-not-exist');
          selectedRadio.disabled = true;
          // shift to the next available option set.
          if (!shiftVariant && availableMap?.length > 0) {
            shiftVariant = true;
            failedOption = selectedRadio;
          }
        }
        // console.log("selected radio check complete");

        // look for siblings
        // console.log("sibling radio check start");
        radios.forEach((radio) => {
          if (radio.value === selectedValue) {
            return true;
          }
          if (unavailableMap && unavailableMap.includes(radio.value)) {
            radio.classList.add('disabled-radio');
          } else if ((!(availableMap) || !(availableMap.includes(radio.value))) && (!(unavailableMap) || !(unavailableMap.includes(radio.value)))) {
            // this combo does NOT exist
            // console.log(`sibling radio with value "${radio.value}" not found in either maps.`);
            radio.classList.add('does-not-exist');
            radio.disabled = true;
          }
        });
        // console.log("sibling radio check complete");

        const keyPrefix = `${selectedOption1}`;
        const shouldCheckAvailableOptions = Object.keys(this.availableOptionsMap).some(key => key.startsWith(keyPrefix));
        // console.log(`Looking for additional unavailable maps for options on the above level that start with "${keyPrefix}" for "${selectedValue}"`);
        for (const key in this.unavailableOptionsMap) {
          if (key.startsWith(keyPrefix)) {
            // console.log(`Checking out map "${key}" for "${selectedValue}"`);
            const secondLevelRadio = this.querySelector(`.product-form__input-option[data-index="2"][value="${key.split(' / ')[1]}"]`);
            if (!secondLevelRadio) {
              continue;
            }
            if (this.unavailableOptionsMap[key].includes(selectedValue)) {
              // console.log(`map "${key}" contains "${selectedValue}"`);
              this.setRadioClass(secondLevelRadio, 'disabled-radio');
            } else if (!shouldCheckAvailableOptions || !this.availableOptionsMap[key]?.includes(selectedValue)) {
              // console.log(`above level radio with value "${secondLevelRadio.value}" not found in either maps.`);
              this.setRadioClass(secondLevelRadio, 'does-not-exist');
              secondLevelRadio.disabled = true;
            }
          }
        }
      }
    });
    if (shiftVariant) {
      // console.log("The selected option combo resulted in a non-existant variant combination, shifting to the next available option set.");
      // here we have determined we should shift variant, most likely the customer changed one of the product options that equaled a hidden or non-existant combo. We want to move to the next available.

      let failedIndex = failedOption.dataset.index;
      // console.log(failedIndex);
      let failedFieldset = this.querySelector(`fieldset[data-option-index-int="${failedIndex}"]`);
      if(failedFieldset){
        let options = failedFieldset.querySelectorAll('input.product-form__input-option');
        let newOption = Array.from(options).find(option => !option.classList.contains('does-not-exist'));
        if (newOption) {
          failedOption.checked = false;
          newOption.checked = true;
          this.shiftedOption = newOption;
          return false;
        } else {
          // console.log('Unable to find new variant to shift to');
        }
      } else {
        // console.log(`Unable to find fieldset under selector fieldset[data-option-index-int="${failedIndex}"]`);
      }
    } else {
      // console.log("The selected option combo resulted in a existing variant combination.");
      return true;
    }
  }

  setRadioClass(radio, className) {
    if(!radio) return;
    radio.classList.remove('does-not-exist');
    radio.classList.remove('disabled-radio');
    radio.classList.add(className);
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);


class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    // initialize with selected swatch color
    this.radios = document.querySelector('variant-radios');
    if (!this.radios) return;
    this.radios.updateButtonStyle();
    this.radios.updateColorMessaging();
    this.radios.updateColorGroups();
    this.radios.updateColorLabels();

    this.addEventListener('change', () => this.radios.updateButtonStyle())
    this.addEventListener('change', () => this.radios.updateColorMessaging())
  }

  onSubmitHandler(evt) {
    if ((document.body.classList.contains('template-cart') || !shopSettings.cartDrawer) && !document.querySelector('#rebuy-cart')) {
      return;
    }

    // override for doubling
    return;

    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) {
      return;
    }

    this.handleErrorMessage();

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    const formData = new FormData(this.form);
    const formParams = new URLSearchParams(formData);
    const tempObject = Object.fromEntries(formParams);
    const configBody = {};
    let formDataJSON = {};
    // Shopify AJAX Cart API only cares for these parameters.
    const accepted_keys = ['id', 'quantity', 'properties', 'selling_plan'];
    for (let key in tempObject) {
      // check if key starts with one of the accepted keys and the value is not empty
      if (accepted_keys.some(accepted_key => key.startsWith(accepted_key)) && tempObject[key] !== "") {
        if (key.startsWith('properties')) {
          if (!formDataJSON['properties']) {
            formDataJSON['properties'] = {};
          }
          let innerKey = key.split('[')[1].split(']')[0];
          // check if value is not empty
          if (tempObject[key] !== "") {
            formDataJSON['properties'][innerKey] = tempObject[key];
          }
        } else {
          if (tempObject[key] !== "") {
            formDataJSON[key] = tempObject[key];
          }
        }
      }
    }

    // if the object strangely has no quantity, make sure we set that and default to 1.
    if (!formDataJSON.hasOwnProperty('quantity')) {
      formDataJSON.quantity = 1;
    }

    // console.log("ProductCard _addItemToCart data", $(data));
    // console.log("ProductCard _addItemToCart formData", formData);
    // console.log("ProductCard _addItemToCart formDataJSON", JSON.stringify(formDataJSON));
    const items_added = [formDataJSON];

    const postBody = {
      items: items_added
    };

    if (this.miniCart && configBody) {
      // formData.append('sections', this.miniCart.getSectionsToRender().map((section) => section.id));
      configBody.sections = this.miniCart.getSectionsToRender().map((section) => section.id);
    }
    // formData.append('sections_url', window.location.pathname);
    postBody.sections_url = window.location.pathname;

    fetch(`${routes.cart_add_url}.js?sections=mini-cart,cart-icon-bubble`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postBody)
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (this.querySelector('product-upsell')) {
          document.dispatchEvent(new CustomEvent('rocket:upsell-add-to-cart'));
        }

        document.dispatchEvent(new CustomEvent("cart:item:added", {
          detail:
          {
            'response': response,
            'items_added': items_added
          }
        }));

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define('product-form', ProductForm);

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      this.style.setProperty('--progress-bar-width', `${quantity * 100 / 30}%`);
    }, 1e3);
  }
}
customElements.define('progress-bar', ProgressBar);

class FormState extends HTMLElement {
  constructor() {
    super();

    this.formInputs = this.querySelectorAll('input,select,textarea');
    this.form = this.querySelector('form');

    this.formInputs.forEach((input) => {
      input.addEventListener('input', this.onInputChange.bind(this));
      input.addEventListener('blur', this.onInputChange.bind(this));
    });

    if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onInputChange(event) {
    this.handleInputCheck(event.target);
  }

  onSubmitHandler(event) {
    let valid = !0;

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1;
      }
    });

    if (!valid) {
      event.preventDefault();
      return;
    }
  }

  handleInputCheck(input) {
    if (input.classList.contains('required')) {

      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove('valid');
        input.classList.add('invalid');

        return !1;
      }
      else {
        input.classList.remove('invalid');
        input.classList.add('valid');

        return !0;
      }
    }

    return !0;
  }
}
customElements.define('form-state', FormState);

class ListMenuItem extends HTMLElement {
  constructor() {
    super();

    this.listMenuHover = this.closest('menu-drawer').querySelector('list-menu-hover');

    this.addEventListener('mouseenter', () => {
      this.listMenuHover.open({
        title: this.dataset.title,
        url: this.dataset.url,
        image: this.dataset.image,
        description: this.dataset.description
      });
    });
  }
}
customElements.define('list-menu-item', ListMenuItem);

class ListMenuHover extends HTMLElement {
  constructor() {
    super();
  }

  open(obj) {
    let html = '';
    const opened = obj.image.length > 0 || obj.description.length > 0;

    if (opened) {
      html += `<a href="${obj.url}" class="hover-collection${obj.image.length > 0 ? '' : ' hover-collection--no-image'}">`;
      html += '<figure class="hover-collection__image"' + (obj.image.length > 0 ? `style="background-image:url(${obj.image})"` : '') + '></figure>';
      html += '<div class="hover-collection__content">';
      html += `<span class="hover-collection__title h4">${obj.title}</span>`;
      html += obj.description.length > 0 ? `<div class="hover-collection__description">${obj.description}</div>` : '';
      html += '</div>';
      html += '</a>';
    }

    this.innerHTML = html;
  }

  close() {
    this.innerHTML = '';
  }
}
customElements.define('list-menu-hover', ListMenuHover);

class TransparentHeader extends HTMLElement {
  constructor() {
    super();

    const header = document.getElementById('shopify-section-header');

    header.classList.add('transparent-header');
    if (this.dataset.showSeparator == 'true') {
      header.classList.add('transparent-separator');
    }
  }
}
customElements.define('transparent-header', TransparentHeader);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('mouseenter', this.onHoverHandler.bind(this));
  }

  onHoverHandler() {
    const image = this.closest('.card-wrapper').querySelector('.media img');

    if (image !== null) {
      image.src = this.dataset.src;
      image.srcset = this.dataset.srcset;

      this.activeColorSwatch();
    }
  }

  activeColorSwatch() {
    this.closest('.card__colors').querySelectorAll('.color-swatch').forEach((color) => {
      color.classList.remove('active');
    });

    this.parentNode.classList.add('active');
  }
}
customElements.define('color-swatch', ColorSwatch);

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler() {
    const variantId = this.dataset.variantId;

    const items_added = [{
      id: variantId,
      quantity: 1
    }];

    const body = {
      items: items_added
    };

    let bodyJSON = JSON.stringify(body);

    if (variantId) {
      if ((document.body.classList.contains('template-cart') || !shopSettings.cartDrawer) && !document.querySelector('#rebuy-cart')) {
        fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body: bodyJSON })
          .then((response) => response.json())
          .then((response) => {
            document.dispatchEvent(new CustomEvent("cart:item:added", {
              detail:
              {
                response: response,
                items_added: items_added
              }
            }));
          })
          .catch((e) => {
            console.error(e);
          });
        return;
      }

      this.setAttribute('disabled', true);
      this.classList.add('loading');
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

      body.sections = sections;
      body.sectios_url = window.location.pathname;

      bodyJSON = JSON.stringify(body);

      fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body: bodyJSON })
        .then((response) => response.json())
        .then((parsedState) => {
          this.miniCart && this.miniCart.renderContents(parsedState);
          document.dispatchEvent(new CustomEvent("cart:item:added", {
            detail:
            {
              response: parsedState,
              items_added: items_added
            }
          }));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove('loading');
          this.removeAttribute('disabled');
        });
    }
  }
}
customElements.define('add-to-cart', AddToCart);

class PriceMoney extends HTMLElement {
  constructor() {
    super();

    if (this.shouldInit()) {
      this.init();
    }
  }

  shouldInit() {
    const moneyFormat = shopSettings.moneyFormat.toLowerCase();
    if (moneyFormat.indexOf('class=') !== -1) {
      return false;
    }

    return true;
  }

  init() {
    const currencies_using_comma_decimals = 'ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND'.split(',');
    const symbol = shopSettings.moneyFormat.replace(/\{{.*}}/, '').trim();
    const bdi = this.querySelector('bdi');
    const price = bdi.textContent;
    let html = price.replace(' ', '');
    let money_symbol_decimal = '.';

    if (currencies_using_comma_decimals.includes(shopSettings.isoCode)) {
      money_symbol_decimal = ',';
    }

    if (price.includes(money_symbol_decimal)) {
      if (price.lastIndexOf(symbol) + symbol.length === price.length) {
        const price_without_symbol = price.slice(0, price.lastIndexOf(symbol));
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price_without_symbol.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
      else {
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
    }

    html = html.replace(symbol, `<span class="price__prefix">${symbol}</span>`);

    bdi.innerHTML = html;
  }
}
customElements.define('price-money', PriceMoney);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.mql = window.matchMedia('(min-width: 750px)');

    this.elements = {
      small: this.querySelector('.slideshow__left'),
      content: this.querySelector('.slideshow__content'),
      large: this.querySelector('.slideshow__right')
    };
    this.settings = {
      autorotate: this.dataset.autorotate == 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll('.slideshow__image'),
      slidesLarge: this.elements.large.querySelectorAll('.slideshow__image')
    };

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
    this.matchMedia();
  }

  init() {
    setTimeout(() => {
      this.flickitySmall = new Flickity(this.elements.small, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
      });

      this.flickityContent = new Flickity(this.elements.content, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: this.mql.matches ? false : true,
        asNavFor: this.elements.small,
        adaptiveHeight: true,
        arrowShape: 'M14.453 30.078q-0.391 1.172-3.125 16.602t-2.539 15.625 16.406 3.125 16.406 2.734 0.195-2.148l0.391-1.563-13.281-2.344q-13.281-2.344-13.281-2.734t2.734-2.344 5.078-3.125q3.906-2.734 9.18-4.688t10.352-2.734q3.516-0.391 8.789-0.391t8.789 0.391q15.625 2.344 28.125 13.281l3.125 2.344 1.563-1.172q1.172-1.172 1.172-1.563t-3.32-3.125-5.273-4.297q-5.078-3.125-11.133-5.664t-11.914-3.711q-3.906-0.781-10.938-0.781t-10.938 0.781q-6.25 1.172-13.281 4.297t-11.719 6.641q-1.563 1.563-1.758 1.367t1.758-12.305l2.344-12.109q0-0.391-1.953-0.781h-1.563q-0.391 0-0.391 0.391z',
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll('.flickity-button');
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute('tabindex', '-1');
              });
            }
          }
        }
      });

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content
      });

      this.bindEvents();
    });
  }

  bindEvents() {
    this.flickitySmall.on('scroll', () => {
      this.flickitySmall.slides.forEach((slide, i) => {
        const flickity = this.flickitySmall;
        const image = this.settings.slidesSmall[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth ? (flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target) : (slide.target + flickity.x);
          }
          else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth ? (slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth) : (slide.target + flickity.x);
          }
          else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * (-1 / 2) + 'px)';
          }
        }
      });
    });

    this.flickityLarge.on('scroll', () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge;
        const image = this.settings.slidesLarge[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth ? (flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target) : (slide.target + flickity.x);
          }
          else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth ? (slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth) : (slide.target + flickity.x);
          }
          else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * (-1 / 2) + 'px)';
          }
        }
      });
    });

    this.elements.content.querySelector('.flickity-button.next').addEventListener('click', () => {
      this.flickitySmall.next();
      this.stopPlayer();
    });

    this.elements.content.querySelector('.flickity-button.previous').addEventListener('click', () => {
      this.flickitySmall.previous();
      this.stopPlayer();
    });

    this.elements.content.querySelectorAll('.flickity-page-dot').forEach((button) => {
      button.addEventListener('click', () => {
        this.stopPlayer();
      });
    });

    let currentIndex = null,
      swipeDirection = null;

    // Detect swipe direction
    this.flickityLarge.on('dragMove', (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex;
      swipeDirection = this.getSwipeDirection(moveVector);

      this.stopPlayer();
    });

    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on('dragEnd', () => {
      if (this.flickityLarge.selectedIndex !== currentIndex) {

        if (swipeDirection === 'left') {
          this.flickitySmall.next();
        }
        else {
          this.flickitySmall.previous();
        }
      }
    });
  }

  stopPlayer() {
    if (this.settings.autorotate) {
      this.flickitySmall.stopPlayer();
    }
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }

  matchMedia() {
    document.addEventListener('matchSmall', () => {
      this.unload();
      this.init();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
      this.init();
    });
  }

  unload() {
    if (this.flickitySmall && typeof this.flickitySmall.destroy === 'function') {
      this.flickitySmall.destroy();
    }
    if (this.flickityContent && typeof this.flickityContent.destroy === 'function') {
      this.flickityContent.destroy();
    }
    if (this.flickityLarge && typeof this.flickityLarge.destroy === 'function') {
      this.flickityLarge.destroy();
    }
  }
}
customElements.define('slideshow-component', SlideshowComponent);

class TestimonialsComponent extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.slider == 'true') {
      this.settings = {
        autorotate: this.dataset.autorotate == 'true',
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed)
      };
      this.slider = this.querySelector('.testimonial__list');
      this.previews = this.querySelector('.testimonial__previews');

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
      theme.initWhenVisible({
        element: this,
        callback: this.update.bind(this),
        threshold: 0
      });
    }
  }

  init() {
    setTimeout(() => {
      this.flickity = new Flickity(this.slider, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
        pageDots: false,
        wrapAround: true,
        draggable: true,
        cellAlign: 'center',
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
        pauseAutoPlayOnHover: true,
        asNavFor: this.previews
      });
      this.flickityNav = new Flickity(this.previews, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        selectedAttraction: 0.2,
        friction: 0.8,
        adaptiveHeight: true,
      });

      this.flickityNav.previous();
      if (this.settings.autorotate) {
        this.flickity.pausePlayer();
      }

      this.flickity.on('staticClick', (_event, _pointer, _cellElement, cellIndex) => {
        if (typeof cellIndex == 'number') {
          this.flickityNav.select(cellIndex);
        }
      });

      // Do stuff based on a successful swipe and it's direction
      this.flickity.on('change', (index) => {
        this.flickityNav.select(index);
      });
    });
  }

  update() {
    setTimeout(() => {
      if (this.flickity && this.flickityNav) {
        this.flickityNav.next();
        if (this.settings.autorotate) {
          this.flickity.unpausePlayer();
        }
      }
    }, 300);
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }
}
customElements.define('testimonials-component', TestimonialsComponent);

class UseAnimate extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('animate', '');
  }
}
customElements.define('use-animate', UseAnimate);

class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);
    this.target = document.querySelector(this.getAttribute('data-target'));

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let force = false;
    if (this.target) {
      const rect = this.target.getBoundingClientRect();
      force = rect.y < rect.height;
    } else {
      force = scrollTop >= this.getOffsetTop(this) - window.innerHeight;
    }

    requestAnimationFrame(force ? this.reveal.bind(this) : this.reset.bind(this));
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}
customElements.define('animate-sticky', AnimateSticky);

class LookbookComponent extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    const hotspots = this.querySelectorAll('.look__hotspot');
    hotspots.forEach((hotspot) => {
      hotspot.classList.add('active');
    });

    setTimeout(() => {
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove('active');
      });
    }, 3e3);
  }
}
customElements.define('lookbook-component', LookbookComponent);

class TabCollage extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.tab-collage__heading').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.querySelectorAll('.tab-collage__heading').forEach(
      (button) => button.addEventListener('mouseover', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    const target = event.target;
    if (target.classList.contains('active')) {
      return;
    }

    this.pauseAllMedia();

    this.querySelectorAll('[data-block-id]').forEach((button) => {
      if (target.dataset.blockId === button.dataset.blockId) {
        button.classList.add('active');
      }
      else {
        button.classList.remove('active');
      }
    });
  }

  pauseAllMedia() {
    this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
  }
}
customElements.define('tab-collage', TabCollage);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product-countdown');
    this.date = new Date(Date.parse(this.dataset.date)).getTime();

    if (isNaN(this.date)) {
      this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();

      if (isNaN(this.date)) {
        this.unload();
        return;
      }
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.timer();
    this.dataset.interval = setInterval(this.timer.bind(this), 1000);
  }

  timer() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.unload();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

    if (this.dataset.compact == 'true') {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${dateStrings.d}</span></div>` : '';
      const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`;

      this.innerHTML = dayHTML + otherHTML;
    }
    else {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? dateStrings.day : dateStrings.days}</div>` : '';
      const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? dateStrings.hour : dateStrings.hours}</div>`;
      const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? dateStrings.minute : dateStrings.minutes}</div>`;
      const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? dateStrings.second : dateStrings.seconds}</div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    }
  }

  unload() {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval);
    }

    this.classList.add('hidden');
    if (this.parent) {
      this.parent.classList.add('hidden');
    }
  }
}
customElements.define('countdown-timer', CountdownTimer);

class GMap extends HTMLElement {
  constructor() {
    super();

    if (!this.dataset.apiKey || !this.dataset.mapAddress) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.prepMapApi.bind(this),
      threshold: 200
    });
  }

  prepMapApi() {
    this.loadScript().then(this.initMap.bind(this));
  }

  loadScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.dataset.apiKey;
    });
  }

  initMap() {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: this.dataset.mapAddress }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        if (Shopify.designMode) { }
      }
      else {
        const mapOptions = {
          zoom: parseInt(this.dataset.zoom),
          center: results[0].geometry.location,
          draggable: true,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        };

        const map = new google.maps.Map(this, mapOptions), center = map.getCenter();

        map.setCenter(center);

        const icon = {
          path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
          fillColor: this.dataset.markerColor,
          fillOpacity: 1,
          anchor: new google.maps.Point(15, 55),
          strokeWeight: 0,
          scale: 0.6
        };

        new google.maps.Marker({
          map: map,
          position: map.getCenter(),
          icon: icon
        });

        const styledMapType = new google.maps.StyledMapType(JSON.parse(this.parentNode.querySelector('[data-gmap-style]').innerHTML));

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        google.maps.event.addDomListener(window, 'resize', function () {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        });
      }
    });
  }
}
customElements.define('g-map', GMap);

class RelatedButtons extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('scroll', this.checkListener.bind(this));
    this.querySelectorAll('a').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  checkListener() {
    const element = document.querySelector(this.dataset.scrollto);
    const show = window.scrollY >= element.offsetTop - element.clientHeight;

    if (show) {
      this.classList.add('is-flipped');
    } else {
      this.classList.remove('is-flipped');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.target;
    const scrollIntoView = document.querySelector(target.getAttribute('href'));

    scrollIntoView.scrollIntoView({ behavior: "smooth" });
  }
}
customElements.define('related-buttons', RelatedButtons);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported('local')) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = 'beyours:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 5)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('recently-viewed-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getQueryString() {
    const cookieName = 'beyours:recently-viewed';
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items.map((item) => "id:" + item).slice(0, 4).join(" OR ");
  }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.background = this.dataset.initMode !== 'template';

    if (this.background) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    else {
      this.init();
    }
  }

  init() {
    this.parentSelector = this.dataset.parent || '.media-wrapper';
    this.parent = this.closest(this.parentSelector);

    switch (this.dataset.type) {
      case 'youtube':
        this.initYoutubeVideo();
        break;

      case 'vimeo':
        this.initVimeoVideo();
        break;

      case 'mp4':
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript('youtube').then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript('vimeo').then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector('video');

    if (player) {
      const promise = player.play();

      // Edge does not return a promise (video still plays)
      if (typeof promise !== 'undefined') {
        promise.then(function () {
          // playback normal
        }).catch(function () {
          player.setAttribute('controls', '');
        });
      }
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = videoType === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
    });
  }

  setAsLoading() {
    this.parent.setAttribute('loading', true);
  }

  setAsLoaded() {
    this.parent.removeAttribute('loading');
    this.parent.setAttribute('loaded', true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement('div');
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: 1,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this)
            }
          });
          clearInterval(playerInterval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector('iframe'); // iframe once YT loads
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.mute();
    if (typeof this.player.playVideo === 'function') this.player.playVideo();

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.youtubePlay() : this.youtubePause();
      });
    }, { rootMargin: '0px 0px 50px 0px' });

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          this.closest('.banner').classList.add('video-interactable');
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (this.background && this.player && typeof this.player.playVideo === 'function') {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (this.background && this.player && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: true,
          height: '100%',
          width: '100%'
        });
        this.player.ready().then(this.onVimeoReady.bind(this));

        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector('iframe');
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.vimeoPlay();
        } else {
          this.vimeoPause();
        }
      });
    }, { rootMargin: '0px 0px 50px 0px' });

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (this.background && this.player && typeof this.player.play === 'function') {
      this.player.play();
    }
  }

  vimeoPause() {
    if (this.background && this.player && typeof this.player.pause === 'function') {
      this.player.pause();
    }
  }
}
customElements.define('video-section', VideoSection);

class BundleProduct extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      souldout: 'price--sold-out',
      onsale: 'price--on-sale',
      nocompare: 'price--no-compare'
    };

    this.price = this.querySelector('.price');
    this.variants = this.querySelector('select');
    if (this.variants) {
      this.variants.addEventListener('change', this.onSelectChange.bind(this));
    }
  }

  onSelectChange(event) {
    const variants = event.target;
    const variant = variants.options[variants.selectedIndex];
    const compare_at_price = parseInt(variant.dataset.compare_at_price || 0);
    const price = parseInt(variant.dataset.price || 0);
    const available = variant.dataset.available === 'true';
    const price_varies = variants.dataset.price_varies === 'true';
    const compare_at_price_varies = variants.dataset.compare_at_price_varies === 'true';

    // Remove classes
    this.price.classList.remove(this.classes.souldout);
    this.price.classList.remove(this.classes.onsale);
    this.price.classList.remove(this.classes.nocompare);

    // Add classes
    if (available === false) {
      this.price.classList.add(this.classes.souldout);
    }
    else if (compare_at_price > price && available) {
      this.price.classList.add(this.classes.onsale);
    }
    if (price_varies == false && compare_at_price_varies) {
      this.price.classList.add(this.classes.nocompare);
    }

    // Change price
    const price__regular = this.querySelector('.price__regular');
    price__regular.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, shopSettings.moneyFormat)}</bdi></price-money>`;

    const price__sale = this.querySelector('.price__sale');
    price__sale.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(compare_at_price, shopSettings.moneyFormat)}</bdi></price-money>`;
    price__sale.querySelector('.price-item--sale').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, shopSettings.moneyFormat)}</bdi></price-money>`;
  }
}
customElements.define('bundle-product', BundleProduct);

class BundleProducts extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.button = this.querySelector('button');
    if (this.button) this.button.addEventListener('click', this.onButtonClick.bind(this));

    this.blocks = this.querySelectorAll('[data-block-id]');
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
    this.blocks.forEach((block) => block.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));
  }

  onEnterHandler(event) {
    this.classList.add('hovering');

    const target = event.target;
    const blockId = target.dataset.blockId;
    this.blocks.forEach((block) => {
      if (target.nodeName === 'BUNDLE-PRODUCT') {
        if (block.nodeName === 'BUNDLE-PRODUCT') {
          block.classList.add('active');
          return;
        }
      }
      if (block.dataset.blockId === blockId) {
        block.classList.add('active');
      }
    });
  }

  onLeaveHandler() {
    this.classList.remove('hovering');
    this.blocks.forEach((block) => block.classList.remove('active'));
  }

  onButtonClick(event) {
    event.preventDefault();

    const ids = this.querySelectorAll('[name="id"]');
    const items_added = [...ids].map(e => e.value).map(e => ({
      id: e,
      quantity: 1
    }));

    const body = {
      items: items_added
    };

    let bodyJSON = JSON.stringify(body);

    console.log(body);
    console.log(bodyJSON);

    if (document.body.classList.contains('template-cart') || !shopSettings.cartDrawer) {
      fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body: bodyJSON })
        .then((response) => response.json())
        .then((response) => {
          document.dispatchEvent(new CustomEvent("cart:item:added", {
            detail:
            {
              'response': response,
              'items_added': items_added
            }
          }));
        })
        .catch((e) => {
          console.error(e);
        });
      return;
    }

    this.handleErrorMessage();

    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

    body.sections = sections;
    body.sections_url = window.location.pathname;

    bodyJSON = JSON.stringify(body);

    fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), body: bodyJSON })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }

        document.dispatchEvent(new CustomEvent("cart:item:added", {
          detail:
          {
            'response': response,
            'items_added': items_added
          }
        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define('bundle-products', BundleProducts);

class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    this.products = this.querySelector('.image-with-text__products');

    this.blocks = this.querySelectorAll('lookbook-component [data-block-index]');
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)));

    this.initSlider();
  }

  onEnterHandler(event) {
    if (this.flickity && typeof this.flickity.select === 'function') {
      const index = parseInt(event.target.dataset.blockIndex);
      this.flickity.select(index);
    }
  }

  onFocusHandler(index) {
    this.blocks.forEach((block) => {
      block.classList.remove('focus');

      if (parseInt(block.dataset.blockIndex) === index) {
        block.classList.add('focus');
      }
    });
  }

  initSlider() {
    this.flickity = new Flickity(this.products, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fade: true,
      setGallerySize: true,
      on: {
        ready: () => {
          this.onFocusHandler(0);
        },
        change: (index) => {
          this.onFocusHandler(index);
        }
      }
    });
  }
}
customElements.define('shop-the-look', ShopTheLook);

class SelectWrapper extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });

    this.select = this.querySelector('select');
    if (this.select) {
      this.select.addEventListener('change', this.handleSelectChange.bind(this));
    }
  }

  init() {
    const style = window.getComputedStyle(this.select);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-wrapper', SelectWrapper);

class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.active = false;
    this.button = this.querySelector('button');
    this.horizontal = this.dataset.layout === 'horizontal';
    this.init();

    theme.initWhenVisible({
      element: this.querySelector('.image-comparison__animate'),
      callback: this.animate.bind(this),
      threshold: 0
    });
  }

  animate() {
    this.setAttribute('animate', '');
    this.classList.add('animating');
    setTimeout(() => {
      this.classList.remove('animating');
    }, 1e3);
  }

  init() {
    if (theme.config.isTouch) {
      this.button.addEventListener('touchstart', this.startHandler.bind(this));
      document.body.addEventListener('touchend', this.endHandler.bind(this));
      document.body.addEventListener('touchmove', this.onHandler.bind(this));
    }
    else {
      this.button.addEventListener('mousedown', this.startHandler.bind(this));
      document.body.addEventListener('mouseup', this.endHandler.bind(this));
      document.body.addEventListener('mousemove', this.onHandler.bind(this));
    }
  }

  startHandler() {
    this.active = true;
    this.classList.add('scrolling');
  }

  endHandler() {
    this.active = false;
    this.classList.remove('scrolling');
  }

  onHandler(e) {
    if (!this.active) return;

    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
      ? event.pageX - this.offsetLeft
      : event.pageY - this.offsetTop;

    this.scrollIt(x);
  }

  scrollIt(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;

    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, (Math.min(x, max)));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty('--percent', mousePercent + '%');
  }
}
customElements.define('image-comparison', ImageComparison);

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector('.promotion');

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.media-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, { rootMargin: '0px 0px 50px 0px' });

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

// Redirecting the SPAM urls start
if (window.location.search !== '' && window.location.search !== '?') {
  const params = new URLSearchParams(window.location.search);
  let queries = {};
  for (var value of params.keys()) {
    queries[value] = params.get(value);
  }
  let blacklist_words = ['zhanbu88.com',];
  for (const [key, value] of Object.entries(queries)) {
    if (
      (/[^\x00-\x7F]+/.test(value) && key === 'q') ||
      (/[^\x00-\x7F]+/.test(value) && key === 'search_query') ||
      (/[^\x00-\x7F]+/.test(value) && key === 's') ||
      (blacklist_words.length && blacklist_words.includes(value))
    ) {
      window.location.href = window.location.href.split('?')[0];
    }
  }
}
// Redirecting the SPAM urls end


// Redirect the URL after the page has loaded
window.addEventListener("DOMContentLoaded", function () {
  // Check if the slug contains two or more occurrences of "https:/"
  var slug = window.location.href;
  var count = (slug.match(/https:\/\//g) || []).length;

  if (count >= 2) {
    // Redirect to the homepage
    window.location.href = "/";
  }
});

// if navigation div contain "#" print nothing
var sections = document.querySelectorAll('.header__menu-item');

sections.forEach(function (section) {
  var href = section.getAttribute('href');
  if (href === '#') {
    section.removeAttribute('href');
  }
});

// track user action on the sidecart
function returnQuantity(element) {
  const cloneQuantityWrapper = element.cloneNode(true);
  cloneQuantityWrapper.querySelector('span').remove();
  return cloneQuantityWrapper.innerText.trim()
}

document.addEventListener('click', (event) => {
  const element = event.target;
  if(!element) return;
  if(element?.offsetParent?.classList.contains('rebuy-cart__flyout-item-info')) {
    let bundleId = Array.from(element.closest('.rebuy-cart__flyout-item').classList).filter(function(value){
      if(value.indexOf('property-_bundle_master_id:') >= 0) {
        return value;
      }
    });

    if(bundleId.length == 0 ) return;

    bundleId = bundleId[0].replace('property-_bundle_master_id:', '');

    if(bundleId) {
      if(element.classList.contains('rebuy-cart__flyout-item-remove')) {
        sessionStorage.setItem('cartAction', 'update|'+bundleId+'|0')
      } else if(element.getAttribute('alt').toLowerCase().indexOf('increase') >= 0) {
        const quantity = Number(returnQuantity(element.previousElementSibling)) + 1;

        sessionStorage.setItem('cartAction', 'update|'+bundleId+'|'+quantity)
      } else if(element.getAttribute('alt').toLowerCase().indexOf('decrease') >= 0) {
        const quantity = Number(returnQuantity(element.nextElementSibling)) - 1;

        sessionStorage.setItem('cartAction', 'update|'+bundleId+'|'+quantity);
      }
    }
  }
});

// Added rebuy cart eventlisteners for bundles
document.addEventListener('rebuy:cart.change', (event) => {
  if(!sessionStorage.getItem('cartAction')) return;
  const cartItems = event.detail.cart.cart.items;
  const cartItemsWrapper = document.querySelector('.rebuy-cart__flyout-items');
  const [action, bundleId, qty] = sessionStorage.getItem('cartAction').split('|');
  let itemsToUpdate = {updates:{}};

  // update bundle items
  cartItems.forEach((value, index) => {
    const itemBundleId = value.properties._bundle_master_id;

    if(itemBundleId === Number(bundleId)) {
      itemsToUpdate['updates'][value.key] = Number(qty)
    }
  });

  if(Object.keys(itemsToUpdate.updates).length > 0) {
    cartItemsWrapper.classList.add('loading');
    fetch(`${routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemsToUpdate)
    })
    .then(response => {
      sessionStorage.removeItem('cartAction')
      cartItemsWrapper.classList.remove('loading');
      console.log(response.json());
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
});

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      connectedCallback() {
        const swiperEl = this.querySelector('.js-product-gallery')
        const prevEl = this.querySelector('.js-product-gallery--icon-previous')
        const nextEl = this.querySelector('.js-product-gallery--icon-next')
        const option = {
          init: false,
          spaceBetween: 0,
          slidesPerView: 1,
          preventClicks: true,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          slidesPerGroup: 1,
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          }
        }

        this.$swiper = new Swiper(swiperEl, option)
        this.$swiper.init()
      }

      disconnectedCallback() {
        if (this.$swiper && typeof this.$swiper.destroy === 'function') {
          this.$swiper.destroy(true, true)
        }
      }

      showActiveMedia() {
        const activeSlideIndex = this.$swiper.slides.findIndex(slide => slide.querySelector('img').dataset.mediaId === this.openedBy.getAttribute('data-media-id'))
        this.$swiper.slideTo(activeSlideIndex)

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

function soldOut(){
  const spanSold = document.querySelectorAll('.color__swatch-sold-out');
  document.querySelectorAll('label.color__swatch').forEach((span) => {
   span.classList.remove('crossed');
  })

  spanSold.forEach(span => {
    if (span.innerText.trim() === '(Sold Out)') {
      const label = span.closest('label.color__swatch');
      if (label) {
        label.classList.add('crossed');
      }
    }
  });
}
